import styled, { css } from "styled-components";
export const InfoViewGridBase = styled.section `
	display: flex;
	flex-direction: column;

	.orangePrice {
		color: #ff5a00;
	}
	.tomatoPrice {
		color: #e53b2f;
	}
`;
export const InfoViewGrid2 = styled(InfoViewGridBase) `
	display: flex;
	flex-direction: column;
	> * {
		&:first-child {
			flex: 1 auto;
		}
	}
`;
export const InfoViewGrid1 = styled(InfoViewGridBase) `
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-left: 0.5rem;
	position: relative;
	justify-content: space-between;
`;
export const NameView = styled.p `
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	color: #333;

	${(props) => {
    switch (props.gridCol) {
        case 1:
            return css `
					font-size: 0.875rem;
					font-weight: 400;
					line-height: 1.125rem;
					-webkit-line-clamp: 2;
					min-height: 2.25rem;
				`;
        case 2:
            return css `
					width: 100%;
					padding: 0 0.625rem;
					margin-top: 0.5rem;
					-webkit-line-clamp: 2;
					font-size: 0.75rem;
					font-weight: 400;
					line-height: 1.06rem;
				`;
    }
    return "";
}}
`;
export const NameViewWithTag = styled.img `
	position: relative;
	top: 0.125rem;
	height: 0.75rem;
	margin-top: 0.0625rem;
	margin-right: 0.125rem;
`;
export const PriceView = styled.p `
	display: flex;
	align-items: center;
	font-family: Avenir-Heavy;
	font-weight: 600;

	${(props) => {
    switch (props.gridCol) {
        case 1:
            return css `
					margin-top: 0.5rem;
					font-size: 1rem;
					line-height: 1.375rem;
				`;
        case 2:
            return css `
					padding: 0 0.625rem;
					margin-top: 0.25rem;
					display: flex;
					align-items: center;
					font-size: 0.875rem;
					line-height: 1.1875rem;
				`;
        case 3:
            return css `
					padding: 0.5rem 0;
					font-size: 0.875rem;
					line-height: 1.1875rem;
					justify-content: center;
				`;
    }
    return "";
}}
`;
export const OriginalPriceView = styled.p `
	color: #999;
	font-size: 0.75rem;
	line-height: 1.0625rem;
	text-decoration: line-through;
	font-weight: 400;
`;
export const LTTitleIconView = styled.img `
	height: 1.125rem;
`;
export const CollectViewOrange = styled.span `
	font-weight: 400;
	font-size: 0.75rem;
	line-height: 0.875rem;
	color: #999;
`;
export const CollectViewTomato = styled.section `
	display: flex;
	justify-content: flex-end;

	${(props) => {
    switch (props.gridCol) {
        case 1:
            return css `
					flex: 1;
					img {
						display: inline-block;
						width: 0.9375rem;
						height: 0.875rem;
					}
					span {
						margin-left: 0.3125rem;
						color: #666;
						font-size: 0.75rem;
						font-family: Avenir-Heavy;
						line-height: 1rem;
					}
				`;
        case 2:
            return css `
					flex: 1 0 auto;
					img {
						width: 0.9375rem;
						height: 0.875rem;
					}
					span {
						color: #666;
						font-size: 0.75rem;
						font-family: Avenir-Heavy;
						line-height: 1rem;
						margin-left: 0.25rem;
					}
				`;
    }
    return "";
}}
`;
export const InfoBottomStyle2 = styled.section `
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0.5rem 0 0.25rem;
	${(props) => {
    switch (props.gridCol) {
        case 1:
            return css `
					margin-top: 0.375rem;
				`;
        case 2:
            return css `
					width: 100%;
					padding: 0 0.625rem;
				`;
    }
    return "";
}}
`;
export const InfoBottomLeftText = styled.span `
	color: #999;
	font-weight: 400;
	font-size: 0.75rem;
	line-height: 0.8125rem;
`;
